import { IAPIProgramAndLevelsModels, IAPIProgramLevelsModels } from "../interfaces";

export class ProgramAndLevelsModel {
    id: string;
    name: string;
    levels: ProgramLevelsModel[];
    constructor(data?: Partial<ProgramAndLevelsModel>) {
        this.id = (data && data.id) || '';
        this.name = (data && data.name) || '';
        this.levels =
            (data &&
                data.levels?.map((d) => {
                    return new ProgramLevelsModel(d);
                })) ||
            [];
    }

    static deserializeAPIModel(data: IAPIProgramAndLevelsModels[]): ProgramAndLevelsModel[] {
        const list: ProgramAndLevelsModel[] = [];

        if (Array.isArray(data)) {
            data.forEach((d) => {
                const mappedData: Partial<ProgramAndLevelsModel> = {
                    id: d.id,
                    name: d.name,
                    levels: ProgramLevelsModel.deserializeAPIModel(d.levels),
                };

                list.push(new ProgramAndLevelsModel(mappedData));
            });
        }
        return list;
    }
}

export class ProgramLevelsModel {
    id: string;
    name: string;
    constructor(data?: Partial<ProgramLevelsModel>) {
        this.id = (data && data.id) || '';
        this.name = (data && data.name) || '';
    }

    static deserializeAPIModel(data: IAPIProgramLevelsModels[]): ProgramLevelsModel[] {
        const list: ProgramLevelsModel[] = [];

        if (Array.isArray(data)) {
            data.forEach((d) => {
                const mappedData: Partial<ProgramLevelsModel> = {
                    id: d.id,
                    name: d.name,
                };

                list.push(new ProgramLevelsModel(mappedData));
            });
        }
        return list;
    }
}
